import { defineComponent, ref, openBlock, createBlock, unref, normalizeClass, withCtx, createVNode, createElementVNode, createElementBlock, toDisplayString, createCommentVNode, withModifiers, withKeys } from "vue";
import { V as VaFileUploadKey } from "../types.js";
import { V as VaButton } from "../../va-button/index.js";
import { V as VaListItem, a as VaListItemSection } from "../../va-list/index.js";
import { V as VaFileUploadUndo } from "../VaFileUploadUndo/index.js";
import { u as useTranslation } from "../../../composables/useTranslation.js";
import { u as useStrictInject } from "../../../composables/useStrictInject.js";
import { u as useFocus } from "../../../composables/useFocus.js";
import { u as useBem } from "../../../composables/useBem.js";
const _hoisted_1 = { class: "va-file-upload-list-item__content" };
const _hoisted_2 = {
  key: 0,
  class: "va-file-upload-list-item__name"
};
const _hoisted_3 = { class: "va-file-upload-list-item__size" };
const INJECTION_ERROR_MESSAGE = "The VaFileUploadListItem component should be used in the context of VaFileUpload component";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaFileUploadListItem"
  },
  __name: "VaFileUploadListItem",
  props: {
    file: { type: Object, default: null },
    color: { type: String, default: "success" },
    ariaRemoveFileLabel: { type: String, default: "$t:removeFile" }
  },
  emits: ["remove"],
  setup(__props, { emit: __emit }) {
    const { tp } = useTranslation();
    const emit = __emit;
    const {
      undo,
      disabled,
      undoDuration
    } = useStrictInject(VaFileUploadKey, INJECTION_ERROR_MESSAGE);
    const { onFocus, onBlur } = useFocus();
    const removed = ref(false);
    const removeFile = () => {
      if (undo.value) {
        removed.value = true;
        setTimeout(() => {
          if (removed.value) {
            emit("remove");
            removed.value = false;
          }
        }, undoDuration.value ?? 0);
      } else {
        emit("remove");
        removed.value = false;
      }
    };
    const recoverFile = () => {
      removed.value = false;
    };
    const computedClasses = useBem("va-file-upload-list-item", () => ({
      undo: removed.value
    }));
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(VaListItem), {
        class: normalizeClass(["va-file-upload-list-item", unref(computedClasses)]),
        tabindex: "-1",
        disabled: unref(disabled),
        "aria-disabled": unref(disabled)
      }, {
        default: withCtx(() => [
          removed.value && unref(undo) ? (openBlock(), createBlock(unref(VaListItemSection), { key: 0 }, {
            default: withCtx(() => [
              createVNode(unref(VaFileUploadUndo), { onRecover: recoverFile })
            ]),
            _: 1
          })) : (openBlock(), createBlock(unref(VaListItemSection), { key: 1 }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1, [
                __props.file && __props.file.name ? (openBlock(), createElementBlock("div", _hoisted_2, toDisplayString(__props.file && __props.file.name), 1)) : createCommentVNode("", true),
                createElementVNode("div", _hoisted_3, toDisplayString(__props.file && __props.file.size), 1),
                !unref(disabled) ? (openBlock(), createBlock(unref(VaButton), {
                  key: 1,
                  flat: "",
                  color: "danger",
                  icon: "clear",
                  class: "va-file-upload-list-item__delete",
                  "aria-label": unref(tp)(_ctx.$props.ariaRemoveFileLabel),
                  onClick: withModifiers(removeFile, ["stop"]),
                  onKeydown: [
                    withKeys(withModifiers(removeFile, ["stop"]), ["enter"]),
                    withKeys(withModifiers(removeFile, ["stop"]), ["space"])
                  ],
                  onFocus: unref(onFocus),
                  onBlur: unref(onBlur)
                }, null, 8, ["aria-label", "onKeydown", "onFocus", "onBlur"])) : createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 8, ["class", "disabled", "aria-disabled"]);
    };
  }
});
export {
  _sfc_main as _
};

import '../../../../VaFileUploadListItem.css';
//# sourceMappingURL=VaFileUploadListItem.vue_vue_type_script_setup_true_lang.js.map
